import React from "react";
import { useAuth } from "@sdge-hooks";
import { Redirect } from "react-router-dom";
import { paths } from "../../utils/routes";

const AuthLayout: React.FC = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Redirect to={paths.overlapping} />;
  }

  return <>{children}</>;
};

export default AuthLayout;
